module.exports = __webpack_public_path__ + "img/0Q3A3407_L_Wood_MockedUp.0266a79e.jpg";